var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnBoardingActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 5.25C14.75 4.00736 13.7426 3 12.5 3C11.2574 3 10.25 4.00736 10.25 5.25V5.262C10.25 6.50464 11.2574 7.512 12.5 7.512C13.7426 7.512 14.75 6.50464 14.75 5.262V5.25Z",
    fill: "#60636B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.37704C13.7426 9.37704 14.75 10.3844 14.75 11.627V11.639C14.75 12.8817 13.7426 13.889 12.5 13.889C11.2574 13.889 10.25 12.8817 10.25 11.639V11.627C10.25 10.3844 11.2574 9.37704 12.5 9.37704Z",
    fill: "#60636B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.7446C13.7426 15.7446 14.75 16.7519 14.75 17.9946V18.0066C14.75 19.2492 13.7426 20.2566 12.5 20.2566C11.2574 20.2566 10.25 19.2492 10.25 18.0066V17.9946C10.25 16.7519 11.2574 15.7446 12.5 15.7446Z",
    fill: "#60636B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoardingActionIcon);
export default __webpack_public_path__ + "static/media/on-boarding-action-icon.7c9bd6be49be2dcce4b9535f3b251020.svg";
export { ForwardRef as ReactComponent };